import { Injectable } from '@angular/core';
import { BehaviorSubject, take, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  public alert$ = new BehaviorSubject<{ message: string; isError: boolean }>(
    null
  );
  public cancel$ = new BehaviorSubject<string>(null);

  public showAlert({ message, autoClose = true, isError = false }): void {
    this.alert$.next({ message, isError });

    if (autoClose) {
      timer(5000)
        .pipe(take(1))
        .subscribe(() => {
          this.alert$.next(null);
        });
    }
  }

  public hideAlert(): void {
    this.alert$.next(null);
  }
}
